/**
 * Utility function to ensure scrolling to top works consistently across browsers
 * This is a more aggressive approach that uses multiple methods to ensure scrolling works
 */
export const scrollToTop = () => {
  // Method 1: Standard scrollTo
  window.scrollTo(0, 0);
  
  // Method 2: Set scroll properties directly
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0; // For Safari
  
  // Method 3: Use setTimeout to ensure it happens after any pending renders
  setTimeout(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, 0);
  
  // Method 4: Use requestAnimationFrame for next paint cycle
  window.requestAnimationFrame(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  });
};
